export const NOTES_ONBOARDING_STEPS = [
	{
		emoji: "📝",
		title: "Class-Based Organization",
		description: "Keep notes sorted by class automatically, instead of being a giant mess you'll never revisit.",
		gifPath: "/first-time/notes/ClassBased.webm",
	},
	{
		emoji: "🤖",
		title: "AI-Powered Lecture Notes",
		description: "Catch what you might miss in class with real-time transcription and smart summaries.",
		gifPath: "/first-time/notes/Transcript.webm",
	},
	{
		emoji: "📚",
		title: "AI Engagement with Notes",
		description: "Turn your notes into flashcards, quizzes, or even a podcast — study the way that works best for you.",
		gifPath: "/first-time/notes/AIEngagement.webm",
	},
];

export const ASSIGNMENTS_ONBOARDING_STEPS = [
	{
		emoji: "🗂️",
		title: "Clean Assignment Overview",
		description: "All your due dates in one place — no more digging through multiple tabs and missing something.",
		gifPath: "/first-time/assignments/Overview.webm",
	},
	{
		emoji: "📅",
		title: "Planning Tool",
		description: "Decide when you'll actually do your work, not just track deadlines.",
		gifPath: "/first-time/assignments/Plan.webm",
	},
	{
		emoji: "🔄",
		title: "Calendar Sync",
		description: "Your school life finally talks to your real life calendar — assignments, class times, and planned work times all in one view.",
		gifPath: "/first-time/assignments/Sync.webm",
	},
];
